import React, { MouseEvent } from "react";

import { Button } from "@/components/atoms/prime/Button";
import { AddIcon, SlashIcon } from "@/components/atoms/icons";
import GoBack from "@/components/molecules/GoBack/GoBack.component";
import SearchComponent from "@/components/molecules/Searchbar/Search.component";

type SearchProps = {
  value?: string;
  placeholder?: string;
};

type Props = {
  isCreateAllowed?: boolean;
  /**
   * @deprecated use onNew instead
   */
  handleEvent?: (e?: unknown) => void;
  title: string;
  children?: React.ReactNode;
  onNew?: (e?: MouseEvent) => void;
  onSearch?: (query: string) => void;
  showBack?: boolean;
  searchProps?: SearchProps;
};

const Header = ({
  title,
  handleEvent,
  isCreateAllowed = false,
  children,
  onNew,
  onSearch,
  showBack,
  searchProps = {},
}: Props) => {
  const onClickNew = () => {
    if (onNew) {
      onNew();
    } else if (handleEvent) {
      handleEvent();
    }
  };

  return (
    <div className="mb-3 mt-4 flex w-full flex-wrap items-center justify-between gap-1">
      <div className="flex items-center">
        {showBack && (
          <>
            <GoBack />

            <SlashIcon className="text-primary-800" size={16} />
          </>
        )}

        <h2 className="font-bold text-primary-800">{title}</h2>
      </div>
      <div className="flex flex-1 flex-wrap items-center justify-end gap-2">
        {onSearch && <SearchComponent {...searchProps} onSearch={onSearch} />}
        {isCreateAllowed && (
          <Button icon={<AddIcon />} label="Nuevo" severity="secondary" onClick={onClickNew} />
        )}
        {children}
      </div>
    </div>
  );
};

export default Header;
